var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPauseSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,0H7C5.3457031,0,4,1.3457031,4,3v26c0,1.6542969,1.3457031,3,3,3h4c1.6542969,0,3-1.3457031,3-3V3 C14,1.3457031,12.6542969,0,11,0z M12,29c0,0.5517578-0.4482422,1-1,1H7c-0.5517578,0-1-0.4482422-1-1V3 c0-0.5517578,0.4482422-1,1-1h4c0.5517578,0,1,0.4482422,1,1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,0h-4c-1.6542969,0-3,1.3457031-3,3v26c0,1.6542969,1.3457031,3,3,3h4c1.6542969,0,3-1.3457031,3-3V3 C28,1.3457031,26.6542969,0,25,0z M26,29c0,0.5517578-0.4482422,1-1,1h-4c-0.5517578,0-1-0.4482422-1-1V3 c0-0.5517578,0.4482422-1,1-1h4c0.5517578,0,1,0.4482422,1,1V29z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseSmall);
export default __webpack_public_path__ + "static/media/pause--small.59494138c482a9bde2071fc28c6a8b52.svg";
export { ForwardRef as ReactComponent };